var pagination = {

	elms: {
		triggerEl: $('[data-page-trigger]'),
		paginationType: null,
		pagesElms: $('[data-page]')
	},


	removePagination: function(event) {
		//console.log( "pagination: removePagination" );

		// We will use the paginationType to construct the item element
		var $item = $('.' + pagination.elms.paginationType + '');

		// If items are already wrapped in pages, unwrap them
		$item.each(function( index ) {
			if ($(this).parent().is('[data-page]')) {
				$(this).unwrap();
			}
		});

		pagination.insertPagination();
	},


	productWrap: function($item) {
		//console.log( "pagination: productWrap" );

		$item.removeClass('product-fourth').removeClass('product-third').removeClass('product-second');

		var visibleCount = 0;
		// Iterate through the items and add a 'product-page' wrapper for every 12 items
		$item.each(function( index ) {

			var $this = $(this);
			$this.addClass('in-page');

			// if item visible update count and check if time to wrap with page
			if (!$this.hasClass('filter-hidden')){
				visibleCount++;

				if (visibleCount % 12 === 0) {
					$('.in-page').wrapAll('<div class="product-page items-page paging-block grid-wrap" data-page></div>');
					$('.in-page').removeClass('in-page');
					visibleCount = 0;
				}
			}
		});

		pagination.setProductClasses();

		// if there are any visible items left over wrap in page
		if ($('.in-page').length !== $('.in-page.filter-hidden').length) {
			$('.in-page').wrapAll('<div class="product-page items-page paging-block grid-wrap" data-page></div>');
		}

		$('.in-page').removeClass('in-page');
		pagination.elms.pagesElms = $('[data-page]');

		// Add the classes 'current' and 'show' to the first items page
		var $itemsPage = $('.items-page').first().addClass('current');

		pagination.loadPage($itemsPage, function() {
			setTimeout(function(){$('.items-page').first().addClass( 'show' );}, 1);
			pagination.updateLoadMoreDisplay();
		});
	},


	widgetWrap: function($item) {

		// A helper function to get column sizes from the element class names
		function getElColSize($el) {
			if ( $el.is('.grid-3') || $el.is('.widget:not(.grid-item)') ){
				return 3;
			} else if ($el.is('.grid-2') ) {
				return 2;
			} else {
				return 1;
			}
		}

		// Adds a class to the items to flag which row it is in
		// Also separates the initial rows from the rows within the pagination (initially hidden rows)
		function getRowsOfItems() {

			var rowCount = 0;
			var rowsForPaginationCount = 1;
			var columnsUsedInRow = 0;

			// Rows to show initially before show more button
			var initialRows = parseInt(pagination.elms.triggerEl.attr('data-rows'));

			// If there are 0 initial rows wanting to be shown, we'll make an empty div which will be wrapped by a fake page to keep the rest of the code still working normally
			if ( initialRows === 0 ) {
				$('<div class="not-in-pagination"></div>').insertBefore($item.first());
			}

			// Iterate over items and decifer which go into a row based on the grid item class
			$item.each(function( index ) {
				var $this = $(this);

				// If space left in current row
				if ( (3 - columnsUsedInRow) >= getElColSize($this) ) {

					columnsUsedInRow += getElColSize($this);

					// Add data-row attr only if it's not within the initial rows
					if ( rowCount >= initialRows ) {
						$this.addClass('in-pagination');
						$this.attr('data-row', rowsForPaginationCount);
					}
				// If space left in current row (now for half-width widget layout - grid-half)
				} else if ( (4 - columnsUsedInRow) >= getElColSize($this) && $('.grid-half').length) {

					columnsUsedInRow += getElColSize($this);

					// Add data-row attr only if it's not within the initial rows
					if ( rowCount >= initialRows ) {
						$this.addClass('in-pagination');
						$this.attr('data-row', rowsForPaginationCount);
					}

				// Else move to next row
				} else if ( (12 - columnsUsedInRow) >= getElColSize($this) && $('.grid-half').length) {

					columnsUsedInRow += getElColSize($this);

					// Add data-row attr only if it's not within the initial rows
					if ( rowCount >= initialRows ) {
						$this.addClass('in-pagination');
						$this.attr('data-row', rowsForPaginationCount);
					}

				// Else move to next row
				} else {
					columnsUsedInRow = 0;
					rowCount++;
					if ( rowCount > initialRows ) {
						rowsForPaginationCount++;
					}

					columnsUsedInRow += getElColSize($this);

					// Add data-row attr only if it's not within the initial rows
					if ( rowCount >= initialRows ) {
						$this.addClass('in-pagination');
						$this.attr('data-row', rowsForPaginationCount);
					}
				}
			});

			wrapRowsInPages();
		}


		getRowsOfItems();

		// Wraps the rows in pages of 4 rows per page. Also wraps the initial rows in an initially visible page
		function wrapRowsInPages() {
			var rowsPerPage = 4;
			var rowCount = 1;

			// Iterate over items in the pagination to wrap the rows
			$item.each(function( index ) {
				var $this = $(this);

				// If has class to say in-pagination...
				if ( $this.hasClass('in-pagination') ) {

					// The items have already been assigned a row number to say which row they are in
					var itemRowNumber = parseInt($this.attr('data-row'));

					// Add the item to be in the page with a class
					$this.addClass('in-page');

					// When the item rowNumber changes, increase counter
					if ( rowCount !== itemRowNumber ) {
						rowCount = itemRowNumber;
					}

					if ( parseInt($this.next().attr('data-row')) !== itemRowNumber ) {

						// If we get to the next page...
						if ( rowCount % 4 === 0 ) {

							// Wrap all the items we have previously given an in-page class, in a page wrapper
							if ($('.page-news').length) {
								$('.in-page').wrapAll('<div class="items-page paging-block" data-page></div>');
							} else {
								$('.in-page').wrapAll('<div class="items-page paging-block grid-wrap" data-page></div>');
							}

							// Remove the in-page class and reset rowCount to 0, so that we can move on to the next lot
							$('.in-page').removeClass('in-page');
						}
					}
				} else {
					$this.addClass('not-in-pagination');
				}

			});


			// If there are any in page widgets left over, wrap them up
			if( $('.in-page').length > 0 ) {
				if ($('.page-news').length) {
					$('.in-page').wrapAll('<div class="items-page paging-block" data-page></div>');
				} else {
					$('.in-page').wrapAll('<div class="items-page paging-block grid-wrap" data-page></div>');
				}
			}

			// Wrap the initial rows in a div as well
			if ($('.page-news').length) {
				$('.not-in-pagination').wrapAll('<div class="initial-page items-page paging-block current show" data-page></div>');
			} else {
				$('.not-in-pagination').wrapAll('<div class="initial-page items-page paging-block grid-wrap current show" data-page></div>');
			}

			// load the initial rows
			pagination.loadPage($('.initial-page'));

			// Clean up classes and data attr
			$('.in-pagination, .in-page, .not-in-pagination')
				.removeClass('in-pagination')
				.removeClass('in-page')
				.removeClass('not-in-pagination')
				.removeAttr('data-row');
		}

		// Applying classes to the grid items in order to not get gaps in the grid on tablet
		$('.items-page.paging-block.grid-wrap').each( function() {
			var $page = $(this);
			var $items = $page.find('.grid-item');

			$items.removeClass('grid-hide').removeClass('grid-odd-last');

			var moduleEditorial1Col = $items.last().children(':first').is('.module-editorial:not(.module-editorial-2col)');
			var editorialFeed = $items.last().children(':first').is('.editorial-feed');
			var moduleOffer = $items.last().children(':first').is('.module-offer');

			if ( $items.length % 2 === 1 ) {
				if ( moduleEditorial1Col || editorialFeed || (moduleOffer && !$('.treat').length) ) {
					$items.last().addClass('grid-hide');
				} else {
					if (!$('.page-your-treats').length){
						$items.last().addClass('grid-odd-last');
					}
				}
			}
		});

		pagination.elms.pagesElms = $('[data-page]');

		// Check if there is more than one page, and then show the load more button
		if ( $('.items-page').length > 1 ) {
			pagination.elms.triggerEl.addClass('show');
		}
	},


	insertPagination: function() {
		//console.log( "pagination: insertPagination" );

		// Check if show more button is there
		if ( pagination.elms.triggerEl.length === 0 ) { return; }

		var $item = $('.pagination-content').find('.' + pagination.elms.paginationType + '');

		// Call the correct function dependent on which paginationType we want, and pass in the item el
		if ( pagination.elms.paginationType === 'product') { pagination.productWrap($item); }
		if ( pagination.elms.paginationType === 'widget') { pagination.widgetWrap($item); }
	},


	updateLoadMoreDisplay: function() {
		//console.log( "pagination: updateLoadMoreDisplay" );

		//apply ellipsis again
		$('.ellipsis-new').each(function(){
			ellipsisNew.applyEllipsis($(this), true);
		});

		// If current page has another page after it...
		var hasNextPage = pagination.elms.pagesElms.filter('.current').next('[data-page]').length > 0;

		// show or hide the load more button
		pagination.elms.triggerEl[hasNextPage? 'show':'hide']();
	},


	movePageSelection: function(event) {
		//console.log( "pagination: movePageSelection" );

		event.preventDefault();

		// Get current page
		var current = pagination.elms.pagesElms.filter('.current');
		// Get last page
		var isLast = pagination.elms.pagesElms.last();

		// If next page exists
		if ( current.next('[data-page]').length > 0) {

			// Set loading state to load more button and offset calculation
			pagination.elms.triggerEl.addClass('loading');

			// Get button position
			var buttonPos = pagination.elms.triggerEl.offset().top;
			var offsetVal = 10;

			if (windowWidth >= tablet && windowWidth < desktop) {
				offsetVal = 20;
			}
			if (windowWidth >= desktop) {
				offsetVal = 120;
			}

			// Get next page
			var nextBlock = current.next('[data-page]');

			// Check image load
			pagination.loadPage(nextBlock, function() {

				// Show next page
	            nextBlock.addClass('current').slideDown('slow', function() {

	            	// Scroll to top of new page
	        		$('body').clearQueue().stop().animate({ scrollTop: buttonPos - offsetVal }, 'slow');

	        		// Remove loading state to load more button
	        		pagination.elms.triggerEl.removeClass('loading');

	        		// Add class to fade in content
	            	nextBlock.addClass('show');

					// Remove current class from previous page
	            	current.removeClass('current');

	            	//update loadmore button display
	            	pagination.updateLoadMoreDisplay();

	            	// Trigger re-init hack to initialize slider that was off screen
					if ( nextBlock.find('.slider-manual.slider-full.products').length > 0 ) {
					 	nextBlock.find('.slider-manual.slider-full.products').slick('slickSetOption', 'initialSlide', 0, true);
					}
					// Re-initialise the editorial widgets, so the text is not overflowing
					if ( nextBlock.find('.module-editorial-copy.ellipsis').length > 0 ) {
						ellipsis.editorial.init();
					}
					if ( nextBlock.find('.ellipsis-new').length > 0 ) {
						ellipsisNew.applyEllipsis(nextBlock.find('.ellipsis-new'));
					}

	            });
			});
		}
	},


	loadPage: function (elm, callback) {
		//console.log( "pagination: loadPage" );

		// Get number of images in next page
		var selector = 'img[data-image-load],[data-bg-img-src]';
		var images_to_load = elm.find('[data-category-list]').not('.filter-hidden').find(selector).length;
		var images_loaded = 0;

		// if nothing to load then run callback
		if ( (images_to_load === 0) && (callback !== undefined) ) {

			callback();

		} else {

			// Load images
			elm.find('[data-category-list]').not('.filter-hidden').find(selector).each(function() {
				var $this = $(this);
				var isImageElm = $this.is('[data-image-load]');
				var imgUrl = isImageElm ? $this.attr('data-image-load') : $this.attr('data-bg-img-src');

				if(isImageElm) {
					$this
						.attr('src', imgUrl)
						.load(function() {

							images_loaded++;
							$this.removeAttr('data-image-load');

							// If all are loaded...
				            if (images_loaded >= images_to_load) {

				            	if (callback !== undefined) {
									callback();
				            	}
				            }
						});
				} else {
					var $img = $('<img class="lazy-holder"/>');
					$img.attr('src', imgUrl)
						.load(function() {

							$this.css('background-image', 'url(' + imgUrl + ')');

							images_loaded++;
							$this.removeAttr('data-bg-img-src');

							$this.find('.lazy-holder').remove();

							// If all are loaded...
				            if (images_loaded >= images_to_load) {

				            	if (callback !== undefined) {
									callback();
				            	}
				            }
						});
					$this.append($img);
				}
			});
		}
	},

	setProductClasses: function() {
		$('.product:not(.filter-hidden)').each(function(index){
			if(index % 4 === 0) {
				$(this).addClass('product-fourth');
			}
			if(index % 3 === 0) {
				$(this).addClass('product-third');
			}
			if(index % 2 === 0) {
				$(this).addClass('product-second');
			}
		});
	},

	init: function() {
		//console.log( "pagination: init" );

		// First decide which pagination we are doing (products or widgets) and assign it to the global element
		pagination.elms.paginationType = pagination.elms.triggerEl.attr('data-more');

		// init to remove and then add pagination
		pagination.insertPagination();

		if ( pagination.elms.triggerEl.length > 0 && pagination.elms.pagesElms.length > 0 ) {
			pagination.elms.triggerEl.on('click', pagination.movePageSelection);
			$.subscribe('/filters/updated', pagination.removePagination);
		}
	}
};